import { Link } from '@takeshape/redux-little-router';
import styled from 'styled-components';
import type { useSimpleLink } from './simple-link-hook.js';

const StyledLink = styled(Link)`
  text-decoration: none;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export type SimpleLinkProps = ReturnType<typeof useSimpleLink>;

/*
 * Wrapping a Link in this wrapper addresses an issue with passing it as a component prop to
 * MUI elements and also does a simple style reset. No extra functionality is provided so that
 * it can be used as a transparent wrapper for clickable elements.
 */
export function SimpleLink({ children, href, fullWidth }: SimpleLinkProps) {
  return (
    <StyledLink href={href} style={{ width: fullWidth ? '100%' : 'auto' }}>
      {children}
    </StyledLink>
  );
}
